/* TITAN SUPLEMENTS — capa de interacción
   Vanilla JS, cero dependencias. Powered by Jayffer. */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Tema día / noche ---------- */
  var saved = null;
  try { saved = localStorage.getItem('titan-theme'); } catch (e) {}
  doc.setAttribute('data-theme', saved || 'night');
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-theme-toggle]');
    if (!t) return;
    var next = doc.getAttribute('data-theme') === 'night' ? 'day' : 'night';
    doc.setAttribute('data-theme', next);
    try { localStorage.setItem('titan-theme', next); } catch (err) {}
  });

  /* ---------- Menú móvil: cerrar al navegar, clic fuera o Escape ---------- */
  document.addEventListener('click', function (e) {
    var open = document.querySelector('.t-mnav[open]');
    if (open && (!open.contains(e.target) || e.target.closest('.t-mnav-panel a'))) open.removeAttribute('open');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.t-mnav[open]');
    if (open) open.removeAttribute('open');
  });

  /* ---------- Countdown a corte de despacho ---------- */
  var cd = document.querySelector('[data-countdown]');
  if (cd) {
    var cutoff = parseInt(cd.getAttribute('data-countdown'), 10) || 14;
    var tick = function () {
      var now = new Date(), end = new Date(now);
      end.setHours(cutoff, 0, 0, 0);
      if (end <= now) end.setDate(end.getDate() + 1);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      cd.textContent =
        String(Math.floor(s / 3600)).padStart(2, '0') + ':' +
        String(Math.floor(s % 3600 / 60)).padStart(2, '0') + ':' +
        String(s % 60).padStart(2, '0');
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Parallax 3D del hero ---------- */
  var stage = document.querySelector('[data-hero-stage]');
  if (stage && !reduced) {
    var orbit = stage.querySelector('[data-hero-orbit]');
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      orbit.style.transform = 'rotateY(' + (x * 16) + 'deg) rotateX(' + (-y * 12) + 'deg)';
    });
    stage.addEventListener('mouseleave', function () { orbit.style.transform = ''; });
  }

  /* ---------- Tilt 3D en tarjetas ---------- */
  if (!reduced) {
    document.querySelectorAll('.t-tilt').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(800px) rotateY(' + (x * 7) + 'deg) rotateX(' + (-y * 7) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('t-in'); io.unobserve(en.target); } });
  }, { threshold: 0.12 });
  document.querySelectorAll('.t-rev').forEach(function (el) { io.observe(el); });
  /* la clase de estado del CSS portado es .t-in sobre .t-rev */

  /* ---------- Contadores animados ---------- */
  var nio = new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target, target = +el.dataset.count, dec = +(el.dataset.dec || 0), t0 = null;
      var final = dec ? (target / 10).toFixed(1) : target.toLocaleString('es-CO');
      if (reduced) { el.textContent = final; nio.unobserve(el); return; }
      var step = function (t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / 1400, 1), e = 1 - Math.pow(1 - p, 3), v = target * e;
        el.textContent = dec ? (v / 10).toFixed(1) : Math.round(v).toLocaleString('es-CO');
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      nio.unobserve(el);
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('[data-count]').forEach(function (el) { nio.observe(el); });

  /* ---------- Toast ---------- */
  var toast = document.getElementById('tToast'), toastMsg = document.getElementById('tToastMsg'), tmr;
  function showToast(html) {
    if (!toast) return;
    toastMsg.innerHTML = html;
    toast.classList.add('t-show');
    clearTimeout(tmr);
    tmr = setTimeout(function () { toast.classList.remove('t-show'); }, 4200);
  }
  function fmt(v) { return '$' + Math.round(v).toLocaleString('es-CO'); }

  /* ---------- Carrito AJAX + progreso de envío gratis ---------- */
  var FREE = parseInt((document.body.getAttribute('data-freeship') || '0'), 10); // en centavos
  function refreshCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      n.classList.toggle('t-on', cart.item_count > 0);
    });
  }
  function addItems(items, label) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw r;
      return fetch('/cart.js').then(function (c) { return c.json(); });
    }).then(function (cart) {
      refreshCartCount(cart);
      var ship = FREE > 0
        ? (cart.total_price >= FREE
            ? '<b>Envío gratis desbloqueado</b> — tu pedido viaja por cuenta nuestra.'
            : 'Te faltan <b>' + fmt((FREE - cart.total_price) / 100) + '</b> para el envío gratis.')
        : '';
      showToast('<b>Añadido ✓</b> ' + label + (ship ? '<br>' + ship : ''));
    }).catch(function () {
      showToast('<b>No se pudo añadir.</b> Revisa el stock e inténtalo de nuevo.');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-variant]');
    if (b) {
      e.preventDefault();
      addItems([{ id: parseInt(b.getAttribute('data-add-variant'), 10), quantity: 1 }],
        b.getAttribute('data-title') || 'Producto');
    }
    var s = e.target.closest('[data-add-stack]');
    if (s) {
      e.preventDefault();
      var ids = s.getAttribute('data-add-stack').split(',').filter(Boolean).map(function (id) {
        return { id: parseInt(id, 10), quantity: 1 };
      });
      addItems(ids, s.getAttribute('data-title') || 'Stack del Titán');
    }
  });

  /* ---------- Prueba social en vivo ---------- */
  var buysEl = document.getElementById('tLiveBuys');
  if (buysEl && toast) {
    try {
      var buys = JSON.parse(buysEl.textContent), bi = 0;
      if (buys.length) {
        var liveBuy = function () {
          var b = buys[bi++ % buys.length];
          showToast('<b>' + b[0] + '</b> en ' + b[1] + ' compró <b>' + b[2] + '</b> · ' + b[3]);
        };
        setTimeout(liveBuy, 7000);
        setInterval(liveBuy, 26000);
      }
    } catch (e) {}
  }

  /* ---------- Ruleta del Titán ----------
     "SIGUE INTENTANDO" (segmentos 1 y 5) existe solo para crear tensión: la aguja NUNCA cae ahí.
     Premio válido solo en la primera compra; el código se auto-aplica vía /discount/CODE. */
  var ov = document.getElementById('rouOv');
  if (ov) {
    var cfg = JSON.parse(document.getElementById('rouCfg').textContent);
    /* cfg = {delay, prizes:{'10K':{label,code,weight},'5K':...,'SHIP':...,'GIFT':...}} */
    var SEGS = ['10K', 'TRY', '5K', 'GIFT', 'SHIP', 'TRY', '5K', 'GIFT'];
    var wheelEl = document.getElementById('tWheel'),
        spinBtn = document.getElementById('tSpinBtn'),
        rouRes = document.getElementById('tRouResult'),
        rouClose = document.getElementById('tRouClose'),
        tab = document.getElementById('tWheelTab'),
        modal = ov.querySelector('.t-rou-modal'),
        rouWin = document.getElementById('tRouWin'),
        rouForm = document.getElementById('tRouForm'),
        rouEmail = document.getElementById('tRouEmail'),
        rouOk = document.getElementById('tRouOk'),
        rot = 0, spinning = false, redeemed = false, prizeKey = null;
    try { redeemed = localStorage.getItem('titan-wheel') === '1'; } catch (e) {}
    var openRou = function () { ov.classList.add('t-show'); tab.classList.remove('t-on'); rouClose.focus(); };
    var closeRou = function () { ov.classList.remove('t-show'); if (!redeemed) tab.classList.add('t-on'); };
    if (!redeemed) setTimeout(openRou, (cfg.delay || 6) * 1000);
    rouClose.addEventListener('click', closeRou);
    ov.addEventListener('click', function (e) { if (e.target === ov) closeRou(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ov.classList.contains('t-show')) closeRou(); });
    tab.addEventListener('click', openRou);

    var confetti = function () {
      var colors = ['#F2C94C', '#E5484D', '#7C3AED', '#1FA05A', '#2563EB', '#FFF8E7'];
      for (var i = 0; i < 34; i++) {
        var p = document.createElement('i');
        p.className = 't-cf';
        p.style.setProperty('--dx', (Math.random() * 360 - 180) + 'px');
        p.style.setProperty('--dy', (-40 - Math.random() * 280) + 'px');
        p.style.background = colors[i % 6];
        modal.appendChild(p);
        (function (el) { setTimeout(function () { el.remove(); }, 1300); })(p);
      }
    };
    var pickIdx = function () {
      var w = cfg.prizes, total = w['5K'].weight + w.SHIP.weight + w.GIFT.weight + w['10K'].weight;
      var r = Math.random() * total;
      if ((r -= w['5K'].weight) < 0) return Math.random() < 0.5 ? 2 : 6;
      if ((r -= w.SHIP.weight) < 0) return 4;
      if ((r -= w.GIFT.weight) < 0) return Math.random() < 0.5 ? 3 : 7;
      return 0;
    };
    /* Cada etiqueta vive en su propio angulo fijo (data-base). Al girar la rueda esos
       angulos se desplazan TODOS juntos por "rot" grados -- una correccion de texto
       calculada solo para el reposo (rot=0) deja de servir en cuanto el premio
       cae en cualquier otro segmento. Por eso el volteo se recalcula aqui, en vivo,
       para el angulo final REAL de cada etiqueta, sea cual sea el resultado del giro. */
    /* v3: voltear el grupo entero intercambiaba icono y texto de banda radial
       (el icono terminaba hacia el centro). Ahora cada pieza gira 180 sobre su
       PROPIO centro: el icono queda siempre pegado al aro (r=119) y el texto
       siempre en la banda interior (r=71), ambos legibles y derechos. */
    var wlabels = wheelEl.querySelectorAll('.t-wlabel');
    var orientLabels = function (currentRot) {
      wlabels.forEach(function (g) {
        var base = parseFloat(g.getAttribute('data-base'));
        var eff = ((base + currentRot) % 360 + 360) % 360;
        var flip = eff > 90 && eff < 270;
        var use = g.querySelector('use');
        var txt = g.querySelector('text');
        use.setAttribute('transform', flip ? 'rotate(180 150 31)' : 'rotate(0 150 31)');
        txt.setAttribute('transform', flip ? 'rotate(90 150 79)' : 'rotate(-90 150 79)');
        /* los dy de los tspan siguen al marco del texto tras el rotate: el orden
           de lineas se conserva solo, no compensar (compensar lo invierte) */
      });
    };
    orientLabels(0);
    spinBtn.addEventListener('click', function () {
      if (spinning) return;
      if (redeemed) {
        closeRou();
        var target = document.querySelector('[data-titan-featured]');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
        return;
      }
      spinning = true; spinBtn.disabled = true; rouRes.textContent = '';
      var idx = pickIdx();
      var dur = reduced ? 500 : 4300;
      wheelEl.style.transition = 'transform ' + (dur / 1000) + 's cubic-bezier(.15,.72,.08,1)';
      rot = Math.floor(rot / 360) * 360 + 360 * 5 + (360 - (22.5 + 45 * idx)) + (Math.random() * 26 - 13);
      wheelEl.style.transform = 'rotate(' + rot + 'deg)';
      orientLabels(rot);
      setTimeout(function () {
        spinning = false;
        prizeKey = SEGS[idx];
        rouRes.innerHTML = '<b>¡Ganaste ' + cfg.prizes[prizeKey].label + '!</b>';
        spinBtn.hidden = true;
        rouWin.hidden = false;
        rouEmail.focus();
        tab.textContent = 'Reclama tu premio';
        confetti();
      }, dur + 150);
    });
    rouForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = rouEmail.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        rouEmail.style.borderColor = '#E5484D'; rouEmail.focus();
        rouOk.hidden = false;
        rouOk.style.borderColor = 'rgba(229,72,77,.5)'; rouOk.style.background = 'rgba(229,72,77,.12)';
        rouOk.innerHTML = '<span style="color:#FF8A8E">Escribe un correo válido — es donde queda activado tu premio.</span>';
        return;
      }
      var prize = cfg.prizes[prizeKey];
      /* 1. captura del cliente con tag del premio (form 'customer' de Shopify) */
      var fd = new FormData(rouForm);
      fd.set('contact[email]', v);
      fd.set('contact[tags]', 'ruleta,' + prize.code);
      fetch(rouForm.action, { method: 'POST', body: fd, headers: { 'Accept': 'text/html' } }).catch(function () {});
      /* 2. auto-aplicar el descuento en el checkout vía cookie nativa de Shopify */
      fetch('/discount/' + encodeURIComponent(prize.code), { mode: 'no-cors' }).catch(function () {});
      redeemed = true;
      try { localStorage.setItem('titan-wheel', '1'); } catch (err) {}
      rouForm.hidden = true;
      rouOk.hidden = false; rouOk.style.borderColor = ''; rouOk.style.background = '';
      rouOk.innerHTML = '<b>Premio activado</b> para <b>' + v + '</b>. Se aplicará automáticamente en tu checkout — válido solo en tu primera compra.';
      spinBtn.hidden = false; spinBtn.disabled = false; spinBtn.textContent = 'Ir a comprar →';
      tab.classList.remove('t-on');
      confetti();
    });
  }
})();


/* ===== Buscador overlay (lupa del header) ===== */
(function () {
  var ov = document.getElementById('tSearchOv');
  if (!ov) return;
  var input = document.getElementById('tSearchInput');
  var res = document.getElementById('tSearchRes');
  var deb;
  function openS() { ov.hidden = false; document.body.style.overflow = 'hidden'; setTimeout(function () { input.focus(); }, 40); }
  function closeS() { ov.hidden = true; document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { openS(); return; }
    if (e.target.closest('[data-search-close]') || e.target === ov) closeS();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) closeS(); });
  input.addEventListener('input', function () {
    clearTimeout(deb);
    var q = input.value.trim();
    if (q.length < 2) { res.innerHTML = ''; return; }
    deb = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (!items.length) { res.innerHTML = '<p class="t-search-none">Sin resultados. Prueba con otra palabra.</p>'; return; }
          res.innerHTML = items.map(function (p) {
            var img = '';
            if (p.featured_image && p.featured_image.url) {
              var u = p.featured_image.url;
              img = '<img src="' + u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=90" alt="" loading="lazy">';
            }
            var price = parseFloat(p.price);
            price = isNaN(price) ? String(p.price || '') : '$' + Math.round(price).toLocaleString('es-CO');
            return '<a class="t-search-item" href="' + p.url + '">' + img +
              '<span><strong>' + p.title + '</strong><small>' + (p.vendor || '') + '</small></span>' +
              '<b>' + price + '</b></a>';
          }).join('');
        }).catch(function () {});
    }, 220);
  });
})();
